// @flow
import JQueryView, { on } from '../common/JQueryView';

declare var $: any;

export default class ShowView extends JQueryView {
  constructor() {
    super('.show');
  }

  @on('click .toggle-content')
  onClick(event: any) {
    const id = event.currentTarget.dataset.contentId;
    $(`#${id}`).slideToggle();
    $(event.currentTarget)
      .find('i')
      .toggleClass('fa-chevron-down');
    $(event.currentTarget)
      .find('i')
      .toggleClass('fa-chevron-up');
  }
}
